import { CarouselProvider as PRCCarouselProvider } from 'pure-react-carousel'
import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const StyledCarousel = styled.div<{
  isFullScreen: boolean
}>`
  height: ${o => (o.isFullScreen ? '100%' : 'auto')};

  position: relative;
`

export const CarouselProvider = styled(PRCCarouselProvider)`
  width: 100%;

  ${fromMd} {
    height: 100%;
  }
`

export const PaginationDotsWrapper = styled.div<{
  isImageZoomShown?: boolean
}>`
  bottom: 24px;
  display: ${o => (o.isImageZoomShown ? 'none' : 'flex')};
  justify-content: center;
  position: absolute;
  right: 24px;

  ${fromMd} {
    bottom: 60px;
    display: flex;
    left: 0;
    right: 0;
  }
`
